import Flux from "flux";
import IAction from "../Actions/IAction";

export default new Flux.Dispatcher<IAction>();